import EmptyStateHosting from "../../assets/images/card.png";

function EmptyCard({ createPost }) {
  return (
    <div className="w-[258px] cursor-pointer h-[288px] border-[1px] border-[#E2E4E9] p-[8px] rounded-[16px] ">
      <div className="mx-auto bg-[] mb-[18px] h-[140px] w-[237px]">
        <img
          src={EmptyStateHosting}
          alt="empty state"
          className="mx-auto  w-[237px] text-center object-cover"
        />
      </div>
      <div className="text-center w-[221px] h-[110px] mt-[12px] mx-auto ">
        <h4 className=" mx-auto text-[16px] font-[700] leading-[16px] ">
          Create your events.
        </h4>
        <p className=" my-[8px] mx-auto text-[12px] font-[500] leading-[16px]">
          Anyone in your community can view and attend your events.
        </p>

        <button
          onClick={() => createPost()}
          className="button-black-gradient text-white rounded-[999px] p-[10px] text-[14px] w-[100px] h-[40px]"
        >
          Create Now
        </button>
      </div>
    </div>
  );
}

export default EmptyCard;
